export default __webpack_public_path__ + "static/media/juice-bottle-lockup-mobile@3x.713b05ef.png";